import React, { useMemo } from 'react';
import { winNumbersColor } from '../../../helpers/winNumbersColor';
import { observer } from 'mobx-react-lite';
import { uuid } from '../../../helpers/uuid';
import { useTranslation } from '@pascal/pascal-core';
import { limitsTranslationKeys } from '../../../enums/limitsTranslationKeys';
import { tableBetHistoryStore } from '@pascal/pascal-core/shared/core/store/tableBetHistoryStore';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData } = thirdStep;

  const t = useTranslation();

  const winNumbersResult = useMemo(() => {
    return winNumbersColor(thirdStepData?.roundData?.number);
  }, [thirdStepData]);

  const CurrentBetRow = () => {
    const { additionalParams } = thirdStepData;
    if (additionalParams) {
      const rowBets =
        additionalParams &&
        additionalParams.reduce((acc, cur) => {
          if (cur?.includedMarkets) {
            acc.push(...cur.includedMarkets);
          } else {
            acc.push(cur?.market);
          }
          return acc;
        }, []);
      return (
        <>
          {rowBets.map((item) => {
            const nameAndNumbers = item.name.split('_');
            const [type, ...numbers] = nameAndNumbers;
            return (
              <div key={uuid()} className='pgc-game-history-info-row-wrp'>
                <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
                  <p className='color-type1'>{t(limitsTranslationKeys[type.toUpperCase()])}</p>
                  <p className='color-type1'>{numbers.join('/')}</p>
                </div>
                <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
                  <p className='color-type2'>
                    {item.amount}
                    {thirdStepData.freeBetId ? `(${t('FREE_BET')})` : ''}
                  </p>
                </div>
                <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
                  <p className='color-type2'>{item.winAmount}</p>
                </div>
              </div>
            );
          })}
        </>
      );
    }
    return null;
  };

  return (
    <>
      <div className='pgc-game-history-info-holder-middle'>
        <div className='g-h-result-header'>
          <p className='g-h-result-header-text'>{t('RESULT')}</p>
        </div>
        <div className='g-h-result-img'>
          <div className={`hash-code-img-inner type-${winNumbersResult?.type}`}>
            <p className='hash-code-img-inner-number left'>{winNumbersResult?.numbers[0]}</p>
            <p className='hash-code-img-inner-number center'>{winNumbersResult?.numbers[1]}</p>
            <p className='hash-code-img-inner-number right'>{winNumbersResult?.numbers[2]}</p>
          </div>
        </div>
      </div>
      <div className='pgc-game-history-info-holder-bottom'>
        <div className='pgc-game-history-info-holder-bottom-header'>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p>{t('BET_TYPE')}</p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p>{t('BET')}</p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p>{t('WIN')}</p>
          </div>
        </div>
        <div className='pgc-game-history-info-holder-bottom-section'>
          <CurrentBetRow />
        </div>
        <div className='pgc-game-history-info-holder-bottom-footer'>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p className='color-type3'>{t('TOTAL')}</p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p className='color-type2'>{thirdStepData.amount}</p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p className='color-type2'>{thirdStepData.winAmount}</p>
          </div>
        </div>
      </div>
    </>
  );
});
